
/* -------------------------------------

	Form

------------------------------------- */

$(document).ready(function() {


	/* validator */
	$('form').each(function() {

		$(this).validate({

			ignore: '.ignore',

			rules: {

				telephone : {
					minlength: 7,
					required: true,
				},

				email : {
					minlength: 2,
					required: true,
					email: true
				},

				date : {
					required: true,
					date: true
				}

			}

		});

	});


	/* select */
	$('select.replace').customSelect({

		customClass: 'selectbox',
		mapStyle: true,
		mapCss: false

	});


	/* textarea */
	autosize($('textarea'));


	/* toggle */
	$('.toggle >div label').click(function() {

		var wrapper = $(this).parent('div');

		wrapper.find('input:checked').attr('checked', false);
		$(this).find('input').attr('checked', true);

	});


	/* toggle disabled */
	$('fieldset[disabled] .toggle >div label').click(function() {

		return false;

	});


	/* datepicker */
        $('form:not(.modal-form) .datepicker:not(.deferred) input').glDatePicker({

	    showAlways: false,
	    cssName: 'default',
	    zIndex: 1200,

	    onClick: function(target, cell, date, data) {

	    	var day = (date.getDate() < 10) ? '0' + date.getDate() : date.getDate();
	    	var month = (date.getMonth()+1 < 10) ? '0' + (date.getMonth()+1) : (date.getMonth()+1);
	    	var date = day + '/' + month + '/' + date.getFullYear();

	        target.val(date);

	    }

	});



});



